import * as actionTypes from './actionTypes';
import type { OrganizationEditFormContextType } from './contexts/OrganizationEditFormProvider';
import { OrgParamProps, OrganizationUser, HightouchAllotment } from './types';

/*------------------------------------------------------------------------------------------------*/
/* All Organizations Fetch Actions                                                                           */
/*------------------------------------------------------------------------------------------------*/
/**
 * fetchAllOrganizationsRequest
 * Fetch allOrganizations request action.
 */
export const fetchAllOrganizationsRequest = () => ({
  type: actionTypes.FETCH_ALL_ORGANIZATIONS_REQUEST,
});

/**
 * fetchAllOrganizationsResponse
 */
export const fetchAllOrganizationsResponse = (response: OrgParamProps[]) => ({
  type: actionTypes.FETCH_ALL_ORGANIZATIONS_RESPONSE,
  response,
});

/*------------------------------------------------------------------------------------------------*/
/* Fetch User Actions                                                                           */
/*------------------------------------------------------------------------------------------------*/
/**
 * /**
 * fetchOrganizationUsersRequest
 * Fetch organization users request action.
 */
export const fetchOrganizationUsersRequest = (orgId: number) => ({
  type: actionTypes.FETCH_ORGANIZATION_USERS_REQUEST,
  orgId,
});

/**
 * fetchOrganizationUsersResponse
 * Fetch organization users response action.
 */
export const fetchOrganizationUsersResponse = (response: OrganizationUser[], orgId: number) => ({
  type: actionTypes.FETCH_ORGANIZATION_USERS_RESPONSE,
  response,
  orgId,
});

/*------------------------------------------------------------------------------------------------*/
/* Update Organization Actions                                                                           */
/*------------------------------------------------------------------------------------------------*/
/**
 * updateOrganizationRequest
 * Update organization details
 */
export const updateOrganizationRequest = (
  orgId: OrgParamProps['id'],
  params: OrganizationEditFormContextType,
) => ({
  type: actionTypes.UPDATE_ORGANIZATION_REQUEST,
  orgId,
  params,
});

/*------------------------------------------------------------------------------------------------*/
/* Fetch Hightouch Allotment Actions                                                                           */
/*------------------------------------------------------------------------------------------------*/
/**
 * fetchHightouchAllotmentRequest
 * enablement is hidden behind a feature flag: HightouchIntegration
 */
export const fetchHightouchAllotmentRequest = () => ({
  type: actionTypes.FETCH_HIGHTOUCH_ALLOTMENT_SYNC_LIMIT_REQUEST,
});

/**
 * fetchHightouchAllotmentResponse
 * enablement is hidden behind a feature flag: HightouchIntegration
 */
export const fetchHightouchAllotmentResponse = (response: HightouchAllotment) => ({
  type: actionTypes.FETCH_HIGHTOUCH_ALLOTMENT_SYNC_LIMIT_RESPONSE,
  response,
});

/*------------------------------------------------------------------------------------------------*/
/* Update Hightouch Allotment Actions                                                                           */
/*------------------------------------------------------------------------------------------------*/
/**
 * HightouchAllotmentRequest
 * enablement is hidden behind a feature flag: HightouchIntegration
 */
export const updateHightouchAllotmentRequest = (syncs: number) => ({
  type: actionTypes.UPDATE_HIGHTOUCH_ALLOTMENT_SYNC_LIMIT_REQUEST,
  syncs,
});
